<template>
  <p class="cautionText" :class="{ up: !isLoggedInWithFirebaseAuth }">
    <svg
      width="15"
      height="15"
      viewBox="0 0 38 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.9864 25.7316L22.2149 2.05451C21.4886 0.877363 20.2048 0.160118 18.8213 0.157477C17.4379 0.154947 16.1516 0.868341 15.4209 2.04295L0.625791 25.7591C-0.0739597 26.9865 -0.0739597 28.4924 0.626561 29.7195C1.32708 30.947 2.62338 31.7128 4.03609 31.7347H33.592C35.0103 31.712 36.3103 30.9396 37.0083 29.7053C37.7063 28.4705 37.6982 26.9582 36.9864 25.7316Z"
        fill="#FFD54F"
      />
      <path
        d="M33.592 31.7347H4.03609C2.62338 31.7128 1.32708 30.947 0.626561 29.7195C-0.0739598 28.4924 -0.0739598 26.9865 0.625791 25.7591L15.4209 2.04295C16.1516 0.868341 17.4379 0.154947 18.8213 0.157477C20.2048 0.160118 21.4886 0.877363 22.2149 2.05451L36.9864 25.7316C37.6982 26.9582 37.7063 28.4705 37.0083 29.7053C36.3103 30.9396 35.0103 31.7119 33.592 31.7347ZM17.6773 3.41352L2.88337 27.1297C2.66156 27.5392 2.67025 28.0352 2.9057 28.437C3.1417 28.8389 3.57014 29.0881 4.03609 29.0942H33.592C34.0631 29.0869 34.4954 28.8315 34.7287 28.4225C34.9622 28.0133 34.9622 27.5108 34.7287 27.1017C34.7287 27.1017 19.9573 3.42122 19.9508 3.41352C19.7037 3.02415 19.2748 2.78858 18.814 2.78858C18.3533 2.78858 17.9244 3.02415 17.6773 3.41352Z"
        fill="#FF5360"
      />
      <path
        d="M17.6087 19.3557L17.2576 14.1064C17.1889 13.05 16.8287 11.3429 17.6353 10.4846C18.2491 9.82446 19.7026 9.71103 20.144 10.6261C20.5188 11.7009 20.6017 12.8566 20.3843 13.974L19.9141 19.378C19.8938 19.8869 19.7826 20.3876 19.5853 20.857C19.4271 21.1664 19.1103 21.3624 18.7626 21.3663C18.415 21.3697 18.0944 21.1801 17.9298 20.8741C17.7437 20.3876 17.6358 19.8753 17.6087 19.3557ZM18.825 26.5683C17.9607 26.5636 17.2489 25.8879 17.1996 25.0254C17.1501 24.1624 17.7794 23.4099 18.6372 23.3059C19.0863 23.2516 19.5376 23.3853 19.8845 23.6755C20.2313 23.9656 20.4427 24.3859 20.4685 24.8372C20.4943 25.2888 20.3327 25.7307 20.0211 26.0586C19.71 26.3866 19.2771 26.5708 18.825 26.5683Z"
        fill="#FF5360"
      />
    </svg>
    残りポイントが足りません
  </p>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "caution",
  components: {},
  computed: {
    ...mapState(["isLoggedInWithFirebaseAuth"]),
  },
  methods: {
    ...mapMutations(["setModal"]),
    onClick() {
      this.setModal("signin");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.cautionText {
  background: #ff7e88;
  color: white;
  width: calc(100vw - 1rem);
  right: 0.5rem;
  position: fixed;
  bottom: 3rem;
  border-radius: 4px;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  padding: 0.3rem 0;
  font-size: 0.75rem;
  z-index: 1;
  &.up {
    /* bottom: 5rem; */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyPage/PointShortage.vue